module.exports = __webpack_public_path__ + "img/welcome.9f67965f.jpeg";